import config from 'core/config';
const baseUrl = config.baseurl + '/' + document.querySelector('html').getAttribute('lang').split('-')[0] + '/api/capency';
const headers = {
    'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
};
export const CAPENCY_DEFAULT_COUNTRIES = ['FR', 'UK', 'LU', 'BE', 'CH'];
const cache = {
    mail: {},
    phone: {}
};
const checkMail = async (value) => {
    if (cache.mail[value])
        return await cache.mail[value];
    const p = (async () => {
        try {
            const request = await fetch(`${baseUrl}?api=email&sMail=${value}&request=CheckMailSrvWS`, {
                method: 'POST',
                headers: {
                    ...headers
                }
            });
            const response = await request.json();
            if (response.body.error) {
                throw new Error(response.error.message);
            }
            else {
                return {
                    error: response.body.iRet >= 1,
                    message: response.body.sMessage
                };
            }
        }
        catch (e) {
            console.log(`[CAPEMAIL] an error occured : ${e}`);
        }
    })();
    return await (cache.mail[value] = p);
};
const getPhoneMessage = async (code, country) => {
    const request = await fetch(`${baseUrl}?api=phone&country=${country}&request=GetMessageCP&iReturnValue=${code}`, {
        method: 'POST',
        // charset utf8
        headers: {
            ...headers
        }
    });
    const response = await request.json();
    return response.body;
};
const checkPhone = async (number, country) => {
    if (cache.phone[number])
        return await cache.phone[number];
    if (!number)
        return { error: true, message: 'Phone number is empty' };
    const p = (async () => {
        try {
            const request = await fetch(`${baseUrl}?api=phone&sTel=${number}&country=${country}&request=ProcessPhoneFlow`, {
                method: 'POST',
                headers: {
                    ...headers
                }
            });
            const response = await request.json();
            if (response.body.iReturnValue === 0) {
                return {
                    error: false
                };
            }
            else {
                const messageRequest = await getPhoneMessage(response.body.iReturnValue, country);
                return {
                    error: true,
                    message: messageRequest.sMessage === 'Rejetée' ? config.errors.capencyWrongNumber : messageRequest.message
                };
            }
        }
        catch (e) {
            console.log('[CAPHONE] an error occured :', e);
        }
    })();
    return await (cache.phone[number] = p);
};
const searchAddress = async (query, country) => {
    const encodedQuery = encodeURIComponent(query);
    return fetch(`${baseUrl}?api=address&step=Undefined&country=${country}&request=SearchLine&inputOutput=${encodedQuery}`, {
        method: 'POST',
        headers: {
            ...headers
        }
    });
};
const verifyAddress = async (params) => {
    // create a string with all parameters chained
    if (params.country === 'MC')
        params.locality = 'MONACO';
    const encodedQuery = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
    try {
        const request = await fetch(`${baseUrl}?api=address&request=VerifyAddress&${encodedQuery}`, {
            method: 'POST',
            headers: {
                ...headers
            }
        });
        const response = await request.json();
        return response.body;
    }
    catch (e) {
        console.log(e);
        return {
            error: true,
            message: 'An error occured'
        };
    }
};
const getAvailableCountries = async () => {
    try {
        const request = await fetch(`${baseUrl}?api=address&request=GetAvailableCountries`, {
            method: 'POST',
            headers: {
                ...headers
            }
        });
        const response = await request?.json();
        if (response?.body?.countries?.country)
            return response.body.countries.country.map((country) => country.countryCode.slice(0, 2));
        else
            return CAPENCY_DEFAULT_COUNTRIES;
    }
    catch (e) {
        return CAPENCY_DEFAULT_COUNTRIES;
    }
};
export default {
    checkMail,
    checkPhone,
    searchAddress,
    verifyAddress,
    getAvailableCountries
};
